import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import CreditCard from "./icons/CreditCard";
import {Shopping as ShoppingIcon} from "./icons/Shopping";
import Logout from "./icons/Logout";
import Chores from './icons/Chores'
import QrCode from './icons/QrCode'
import EditProfileIcn from "../../../Authenticated/Components/Sidebar/icons/EditProfileIcn";
import Wallet from "../../../Authenticated/Components/Sidebar/icons/Wallet";
import { isFeatureDisabled, isPermission } from "../../../../Utils";
import { SESSSION_OUT } from "../../../../Utils/constants";
import GoalIcon from "./icons/Goals";
import Charities from "../../../Authenticated/Components/Sidebar/icons/Charities";
import {Chores as ChoreIcon} from "./icons/Chores";
import Settings from "../../../Authenticated/Components/Sidebar/icons/Settings";
import Family from "../../../Authenticated/Components/Sidebar/icons/Family";
import EducationIcon from "../../../Authenticated/Components/Sidebar/icons/EducationIcon";

const Sidebar = ( props) => {

  const { t } = useTranslation();
  const location = useLocation();
  const isBank = !props.showHeader || sessionStorage.getItem("__bank");
  const activeColor = props.state.theme.values.primaryWardColor;
  const defaultColor = props.state.theme.values.tertiaryGrayColor;
  
  const logout = () => {
    document.querySelectorAll(`body`).forEach(e => e.classList.remove(`child-module`));
    document.querySelectorAll(`body`).forEach(e => e.classList.remove(`practice-mode`));
    SESSSION_OUT(props);
  };

  const toggleSidebar = () => {
    document.querySelector('.child-left-sidebar').classList.toggle('active');
  }

  const setActiveBackground = (e) => {
    return window.location.pathname === e ? props.state.theme.values.primaryWardColor+14 : 'transparent';
  }

  return (
    <div className="child-left-sidebar">
      <ul>
        <li onClick={toggleSidebar} className={`${location.pathname === "/child/dashboard" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/child/dashboard')}}>
          <Link to="/child/dashboard">
            <span className="menu-icon">
              <span className="svgIcon">
                <Family {...props} color={location.pathname === "/child/dashboard" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('home')}</span>
          </Link>
        </li>
        {isFeatureDisabled(props,'Chores') === true &&   
          <li onClick={toggleSidebar} className={`${location.pathname === "/child/chores" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/child/chores')}}>
            <Link to="/child/chores">
              <span className="menu-icon">
                <span className="svgIcon">
                  <ChoreIcon {...props} color={location.pathname === "/child/chores" ? activeColor : defaultColor}/>
                </span>
              </span>
              <span>{t('chores')}</span>
            </Link>
          </li>
        }
        <li onClick={toggleSidebar} className={`${location.pathname === "/child/goals" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/child/goals')}}>
          <Link to="/child/goals">
            <span className="menu-icon">
              <span className="svgIcon">
                <GoalIcon {...props} color={location.pathname === "/child/goals" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('goals')}</span>
          </Link>
        </li>
        
        {isFeatureDisabled(props,'Education') === true &&
          <li onClick={toggleSidebar} className={`${location.pathname === "/child/education" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/child/education')}}>
            <Link to="/child/education">
              <span className="menu-icon">
                <span className="svgIcon">
                  <EducationIcon {...props} color={location.pathname === "/child/education" ? activeColor : defaultColor}/>
                </span>
              </span>
              <span>{t('education')}</span>
            </Link>
          </li>
        }
        <li onClick={toggleSidebar} className={`${location.pathname === "/child/shopping" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/child/shopping')}}>
          <Link to="/child/shopping">
            <span className="menu-icon">
              <span className="svgIcon">
                <ShoppingIcon {...props} color={location.pathname === "/child/shopping" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('shopping')}</span>
          </Link>
        </li>
        {isFeatureDisabled(props,'Charity') === true &&
          <li onClick={toggleSidebar} className={`${location.pathname === "/child/charities" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/child/charities')}}>
            <Link to="/child/charities">
              <span className="menu-icon">
                <span className="svgIcon">
                  <Charities {...props} color={location.pathname === "/child/charities" ? activeColor : defaultColor}/>
                </span>
              </span>
              <span>{t('charities')}</span>
            </Link>
          </li>
        }

        <li onClick={toggleSidebar} className={`${location.pathname === "/child/profile" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/child/profile')}}>
          <Link to="/child/profile">
            <span className="menu-icon">
              <span className="svgIcon">
                <EditProfileIcn {...props} color={location.pathname === "/child/profile" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('profile')}</span>
          </Link>
        </li>
      </ul>

      <ul>
        <li onClick={toggleSidebar} className={`${location.pathname === "/child/settings" ? 'active' : ''}`} style={{backgroundColor : setActiveBackground('/child/settings')}}>
          <Link to="/child/settings">
            <span className="menu-icon">
              <span className="svgIcon">
                <Settings {...props} color={location.pathname === "/child/settings" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('settings')}</span>
          </Link>
        </li>
        {!isBank ?
          <li onClick={toggleSidebar} className={`${location.pathname === "/child/logout" ? 'active' : ''}`}>
            <a href="#logout" onClick={logout}>
              <span className="menu-icon">
                <span className="svgIcon">
                  <Logout {...props} color={location.pathname === "/child/logout" ? activeColor : defaultColor}/>
                </span>
              </span>
              <span>{t('sign_out')}</span>
            </a>
          </li>
          : null}
      </ul>
    </div>
  );
};

export default Sidebar;
